
/** @jsxImportSource @emotion/react */

export default function DarkThemeCss(isDarkTheme) {
  if (isDarkTheme === true) {
    return `
      .leaflet-control-measure-toggle {
        background-size: 70% !important;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30px' height='30px' viewBox='0 0 24 24'%3E%3Cpath fill='${isDarkTheme ? "white" : "black"}' d='M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z'/%3E%3C/svg%3E") !important;
        background-position: center; 
        border-radius: 0px !important;
      }

      .leaflet-control-zoom-in, .leaflet-control-zoom-out, .leaflet-control-measure-toggle, .leaflet-draw-draw-polygon, .leaflet-draw-draw-rectangle {
          background-color: #253238 !important;
          color: #f2f2f2 !important;
          transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1);
        }     

      .leaflet-control-measure-interaction, .leaflet-popup, .leaflet-popup-content-wrapper{
        background-color: #253238 !important;
        color: white !important;
      }

      .leaflet-control-zoom-out:hover, .leaflet-control-zoom-in:hover, .leaflet-control-measure-toggle:hover, .leaflet-draw-draw-polygon:hover, .leaflet-draw-draw-rectangle:hover {
        background-color: #25323888;
      }

      .leaflet-control-measure {
        border: 2px solid #39393a;
      }

      .leaflet-draw-draw-rectangle {
        background-size: 70% !important;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='white' %3E%3Cpath d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z'/%3E%3C/svg%3E") !important;
        background-position: center !important; 
        border-radius: 0px !important;
      }

      .leaflet-draw-draw-polygon {
        background-size: 70% !important;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='white' %3E%3Cpath d='M298-120q-26 0-47-15t-29-40L99-543q-8-26 0-51t30-40l305-214q21-14 46-14t46 14l305 214q22 15 30 40t0 51L738-175q-8 25-29 40t-47 15H298Z'/%3E%3C/svg%3E") !important;
        background-position: center !important; 
        border-radius: 0px !important;
      }
    `;

  }
  else {
    return `
        .leaflet-control-measure-toggle {
          background-size: 70% !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30px' height='30px' viewBox='0 0 24 24'%3E%3Cpath fill='${isDarkTheme ? "white" : "black"}' d='M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z'/%3E%3C/svg%3E") !important;
          background-position: center !important; 
          border-radius: 0px !important;
        }

        .leaflet-draw-draw-rectangle {
          background-size: 70% !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='black'%3E%3Cpath d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z'/%3E%3C/svg%3E") !important;
          background-position: center !important; 
          border-radius: 0px !important;
        }

        .leaflet-draw-draw-polygon{
          background-size: 70% !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='black'%3E%3Cpath d='M298-120q-26 0-47-15t-29-40L99-543q-8-26 0-51t30-40l305-214q21-14 46-14t46 14l305 214q22 15 30 40t0 51L738-175q-8 25-29 40t-47 15H298Z'/%3E%3C/svg%3E") !important;
          background-position: center !important; 
          border-radius: 0px !important;
        }

        .leaflet-control-measure {
          border: 2px solid #bfbfbf !important;
        }
      `;
  }
}
